<div class="wrapper">
    <section id="area-breadcrumb">
        <div class="container">
            <nav class="breadcrumb">
                <ul>
                    <li><a href="/"><strong>Home</strong></a></li>
                    <span><i class="fas fa-chevron-right"></i></span>
                    <li *ngIf="!isMobile">Política de Privacidade Montreal Viagens</li>
                    <li *ngIf="isMobile">Política de Privacidade</li>
                </ul>
            </nav>
        </div>
    </section>

    <section id="introducao">
        <div class="container">
            <div class="columns">
                <div class="area-texto column is-offset-1 is-10">
                    <div class="menu-right" *ngIf="!isMobile">
                        <ul class="nav-page">
                            <li><a (click)="scroll('target_guia_rapido')">Guia rápido</a></li>
                            <li><a (click)="scroll('target_fale_conosco')">Fale Conosco</a></li>
                            <li><a (click)="scroll('target_contatos')">Contatos</a></li>
                        </ul>
                    </div>
                    <h1 class="title">Política de Privacidade Montreal Viagens</h1>
                    <p>
                        A Política de Privacidade descreve como os dados pessoais de titulares são tratados,
                        em acordo com a legislação vigente Lei Geral de Proteção de Dados.
                    </p>
<!--                    <p>-->
<!--                        Esta Política de Privacidade descreve como os dados pessoais de titulares são tratados,-->
<!--                        em acordo com a legislação vigente denominada Lei Geral de Proteção de Dados de nº-->
<!--                        13.709, conhecida como LGPD. O tratamento consiste na coleta, armazenamento, uso e-->
<!--                        compartilhamento interno dos dados pessoais.-->
<!--                    </p>-->
<!--                    <p class="clube-hospedagem">-->
<!--                        Quando você interage com nossos sites, canais de atendimento e conteúdo, realizamos a-->
<!--                        coleta de dados para que possamos lhe entregar uma experiência personalizada de-->
<!--                        navegação. Caso você realize a contratação de algum dos serviços e se torne cliente da-->
<!--                        Montreal Viagens, você nos fornece os seus dados pessoais para que possamos viabilizar-->
<!--                        o contrato e executar o fornecimento dos serviços contratados.-->
<!--                    </p>-->
<!--                    <p class="clube-hospedagem">-->
<!--                        Ao navegar em nosso site, você concorda com esta política, fornecendo seu-->
<!--                        consentimento para o tratamento de seus dados pessoais pela empresa MONTREAL - -->
<!--                        HOTÉIS VIAGENS E TURISMO S.A., inscrita no CNPJ 02.703.809/0001-05, com sede em-->
<!--                        Brasília, no SMAS, Área 6580, Trecho 1, ParkShopping Corporate Torre 1, 3° andar. CEP-->
<!--                        71219-900.-->
<!--                    </p>-->
<!--                    <p class="clube-hospedagem">-->
<!--                        Todas as formas de tratamento dos seus dados pessoais estão descritas nesta Política de-->
<!--                        Privacidade.-->
<!--                    </p>-->
                </div>
            </div>
        </div>
    </section>

    <section class="accordions" id="perguntas">
        <div class="container">
            <div class="columns">
                <div class="area-texto column is-offset-1 is-10">
                    <h5 id="target_guia_rapido">Guia rápido</h5>

                    <div id="campo-aplicacao" class="div-filtro accordion">
                        <input type="checkbox" id="btnControl-1" class="btn-control" />
                        <label class="btn" for="btnControl-1">
                            <div class="perguntas">
                                <p>
                                    <i class="fas fa-chevron-down"></i>
                                    <strong>1) Do Campo de Aplicação</strong><br>
                                </p>
                                <label class="area-check">
                                    <div id="introducao-campo-aplicao">
                                        <p>
                                            Esta Política de Privacidade se aplica aos seguintes sites e canais de atendimento:
                                        </p>
                                        <ul>
                                            <li><a target="_blank" href="https://www.viagensmontreal.com/">https://www.viagensmontreal.com</a></li>
                                            <li><a target="_blank" href="https://www.montrealfacilita.com/">https://www.montrealfacilita.com/</a></li>
                                            <li><a target="_blank" href="https://guruviagem.com.br/">https://guruviagem.com.br/</a></li>
                                            <li><a target="_blank" href="https://blogguru.clubemontreal.com.br/">https://blogguru.clubemontreal.com.br/</a></li>
                                            <li><a target="_blank" href="https://www.montrealguru.guru">https://www.montrealguru.guru</a></li>
                                            <li><a target="_blank" href="https://conteudo.pub.clubemontreal.com.br/">https://conteudo.pub.clubemontreal.com.br/</a></li>
                                            <li>
                                                <a target="_blank" href="#" style="cursor: none!important;">
                                                    Atendimento via chatbot, Whatsapp, telefone, e-mail,
                                                    direct do Instagram e mensagens no Facebook
                                                </a>
                                            </li>
                                        </ul>
                                        <p>
                                            O titular tem seus dados tratados pela Montreal na condição de cliente
                                            da Montreal Viagens, visitante dos sites Montreal Viagens e/ou Lead,
                                            conforme descrito abaixo:
                                        </p>
                                    </div>
                                    <div id="visitante-site">
                                        <p><strong>Visitante dos sites:</strong></p>
                                        <p>Você se caracteriza como visitante sempre que está navegando por um dos nossos sites, landing pages, blog ou aplicativo Montreal Viagens.</p>
                                    </div>
                                    <div id="lead-montreal-viagens">
                                        <p><strong>Leads Montreal Viagens:</strong></p>
                                        <p>
                                            São pessoas que interagem com os nossos materiais, conteúdos, landing pages, sites,
                                            e-mails e blogs, optando por compartilhar conosco seus dados de contatos, por meio
                                            das interações com os nossos formulários. Também são consideradas Leads pessoas
                                            que já tenham solicitado a contratação de um dos nossos serviços, mas que não
                                            tenham se tornado um cliente da Montreal Viagens por qualquer motivo.
                                        </p>
                                    </div>
                                    <div id="cliente-montreal-viagens">
                                        <p><strong>Clientes Montreal Viagens:</strong></p>
                                        <p>São pessoas que possuem algum serviço ou plano ativo da Montreal Viagens.</p>
                                    </div>
                                </label>
                            </div>
                        </label>
                    </div>

                    <div id="tratamento-dados-pessoais" class="div-filtro accordion">
                        <input type="checkbox" id="btnControl-2" class="btn-control" />
                        <label class="btn" for="btnControl-2">
                            <div class="perguntas">
                                <p>
                                    <i class="fas fa-chevron-down"></i>
                                    <strong>2) Do tratamento dos dados pessoais:</strong><br>
                                </p>
                                <label class="area-check">
                                    <div id="introducao-tratamento-dados-pessoais">
                                        <p>
                                            Desde o momento em que você interage com a Montreal Viagens, ao acessar nossas
                                            páginas, dados pessoais são coletados por nós e tratados em nosso parque tecnológico.
                                        </p>
                                        <p>
                                            Ao aceitar os termos desta Política de Privacidade,
                                            <b>você concorda expressamente em fornecer apenas dados pessoais verdadeiros</b>,
                                            atuais e precisos e em não alterar a sua identidade ou seus dados pessoais de qualquer
                                            forma no acesso e na utilização dos nossos produtos ou serviços. Você, titular,
                                            será o único responsável pelas informações falsas,
                                            desatualizadas ou imprecisas que fornecer diretamente à Montreal Viagens.
                                        </p>
                                    </div>
                                    <div id="coleta-dados">
                                        <p><strong>2.1) Da coleta de dados</strong></p>
                                        <p>Os dados são coletados pela Montreal de duas formas: automática ou manual.</p>
                                        <p>
                                            A coleta automática se dá por dispositivos implementados em nossos sites e canais de atendimento, tais
                                            como cookies e ferramentas de analytics (análise estatística de comportamento e navegação).
                                        </p>
                                        <p>
                                            A coleta manual ocorre quando o próprio titular, ao interagir com determinados serviços,
                                            nos informa seus dados.
                                        </p>
                                        <p>Segue abaixo o detalhamento dos momentos de coleta dos dados pessoais:</p>
                                        <ul class="ul-disc">
                                            <li>Navegação nos websites, landing pages e Blogs da Montreal Viagens;</li>
                                            <li>Baixar ou se inscrever em alguns de nossos conteúdos publicados nos sites e/ou blogs;</li>
                                            <li>Ao Contratar ou usar qualquer um dos nossos serviços;</li>
                                            <li>Ao usar o Aplicativo Montreal Viagens;</li>
                                            <li>
                                                Quando utilizar alguns de nossos canais de atendimento: telefone, chatbot,
                                                whatsapp, e-mail, messenger ou direct do Instagram;
                                            </li>
                                            <li>Ao participar de pesquisas ou promoções realizadas pela Montreal Viagens;</li>
                                            <li>Interagir em nossas redes sociais;</li>
                                        </ul>
                                    </div>
                                    <div id="dados-pessoais-coletados">
                                        <p><strong>2.2) Dos dados pessoais coletados</strong></p>
                                        <p>Os dados pessoais coletados pela Montreal Viagens, são divididos nos seguintes grupos:</p>
                                        <ul class="ul-decimal">
                                            <li>
                                                Dados pessoais informados pelo titulas
                                                <ol>
                                                    <li>Dados de contato, como e-mail e telefone;</li>
                                                    <li>Dados cadastrais, como nome, RG, CPF, data de nascimento, endereço;</li>
                                                    <li>Dados de pagamento, como banco, agência bancária, conta corrente e dados encriptados do cartão de crédito;</li>
                                                    <li>Dados profissionais, como vínculo empregatício e renda.</li>
                                                </ol>
                                            </li>
                                            <li>
                                                Dados que coletamos automaticamente
                                                Navegação e dispositivo
                                                <ol>
                                                    <li>
                                                        Endereço IP do dispositivo utilizado para acessar os sites ou
                                                        serviços da Montreal Viagens, bem como, atributos do dispositivo,
                                                        tais como ID, sistema operacional, navegador e modelo;
                                                    </li>
                                                    <li>Interações realizadas e perfil de uso de sites, landing pages, blogs e aplicativo da Montreal Viagens;</li>
                                                    <li>Dados técnicos, como informações de URL, de conexão de rede, do provedor, e do dispositivo;</li>
                                                    <li>Cookies;</li>
                                                    <li>Dados de geolocalização do dispositivo caso você autorize a coleta a partir do seu dispositivo.</li>
                                                </ol>
                                            </li>
                                            <li>
                                                Dados originados pelo uso dos serviços Montreal Viagens
                                                <ol>
                                                    <li>Dados de contratação dos nossos serviços;</li>
                                                    <li>
                                                        Dados de utilização dos nossos serviços, como hotéis utilizados,
                                                        cidade visitadas, quantidade de viagens, datas das reservas
                                                        e histórico de utilização de hotéis;
                                                    </li>
                                                    <li>
                                                        Dados de movimentações financeiras com a Montreal Viagens,
                                                        como histórico de pagamentos, valores pagos e gastos com a rede hoteleira;
                                                    </li>
                                                    <li>Histórico de contatos com os canais de atendimento.</li>
                                                </ol>
                                            </li>
                                            <li>
                                                Dados coletados de terceiros
                                                <ol>
                                                    <li>
                                                        Dados sobre restrições financeiras, tais como:
                                                        negativações, valores devidos, datas de vencimento,
                                                        quantidades de consultas, entre outros;
                                                    </li>
                                                    <li>Informações sobre histórico de crédito;</li>
                                                    <li>Score gerado por agências de crédito;</li>
                                                    <li>
                                                        Dados cadastrais, tais como: nome, filiação, data de nascimento,
                                                        CPF, número de telefone, endereço, entre outros.
                                                    </li>
                                                </ol>
                                            </li>
                                        </ul>
                                    </div>
                                    <div id="finalidade-dados-pessoais-coletados">
                                        <p><strong>2.3) Das finalidades para a coleta de dados pessoais</strong></p>
                                        <p>
                                            A Montreal Viagens utiliza os seus dados pessoais com o objetivo de prestar um serviço personalizado e de
                                            alta qualidade.
                                        </p>
                                        <p>
                                            Abaixo seguem as finalidades de utilização dos seus dados pessoais:
                                        </p>
                                        <ul class="ul-decimal">
                                            <li>
                                                Dados pessoas informados pelo titular
                                                <ol>
                                                    <li>Prestação dos serviços e efetivação das contratações;</li>
                                                    <li>Identificação e verificação de requisitos para contratação dos serviços da Montreal Viagens;</li>
                                                    <li>Atendimento ao cliente;</li>
                                                    <li>
                                                        Contato por telefone, e-mail, SMS, WhatsApp,
                                                        ou outros meios de comunicação, envio de notificações
                                                        ou push de uso dos serviços, ofertas e promoções Montreal Viagens;
                                                    </li>
                                                    <li>Envio de brindes, correspondências e comunicações em geral;</li>
                                                    <li>
                                                        Aprimoramento dos serviços prestados pela Montreal Viagens,
                                                        com o cruzamento de informações sobre os serviços contratados
                                                        para oferecimento de novos serviços;
                                                    </li>
                                                    <li>
                                                        Marketing, prospecção, pesquisas de mercado, de opinião
                                                        e promoção dos nossos produtos e serviços, ou de nossos parceiros,
                                                        inclusive com viabilização de ofertas e envio de informações sobre
                                                        produtos, serviços, novidades, funcionalidades, conteúdos,
                                                        notícias e demais eventos relevantes para a manutenção
                                                        do relacionamento com você;
                                                    </li>
                                                    <li>Cobrança da prestação dos serviços;</li>
                                                    <li>
                                                        Proteção ao crédito, investigações e medidas de prevenção
                                                        e combate a fraudes e garantia da segurança dos clientes
                                                        da Montreal Viagens;
                                                    </li>
                                                    <li>Exercício de direitos da Montreal Viagens;</li>
                                                    <li>
                                                        Colaboração ou cumprimento de ordem judicial,
                                                        de autoridade competente ou de órgão fiscalizador;
                                                    </li>
                                                    <li>Cumprimento de obrigação legal;</li>
                                                </ol>
                                            </li>
                                            <li>
                                                Dados que coletamos automaticamente Navegação e dispositivo
                                                <ol>
                                                    <li>
                                                        Oferecimento dos produtos e aperfeiçoamento do uso e experiência
                                                        com o aplicativo, landing pages e sites da Montreal Viagens;
                                                    </li>
                                                    <li>
                                                        Recomendação de novos serviços, planos, hotéis ou funcionalidades,
                                                        inclusive serviços de parceiros que possam te interessar;
                                                    </li>
                                                    <li>Exibição de publicidade, no nossos site, site de terceiros ou redes sociais;</li>
                                                    <li>Geração de estatísticas relacionadas às atividades e comportamento no uso dos nossos serviços;</li>
                                                    <li>Exercício de direitos da Montreal Viagens;</li>
                                                    <li>Colaboração ou cumprimento de ordem judicial, de autoridade competente ou de órgão fiscalizador;</li>
                                                    <li>Cumprimento de obrigação legal;</li>
                                                </ol>
                                            </li>
                                            <li>
                                                Dados originados pelo uso dos serviços Montreal Viagens
                                                <ol>
                                                    <li>Autenticação de transações, atendimento e suporte ao cliente;</li>
                                                    <li>
                                                        Aprimoramento dos serviços prestados pela Montreal Viagens,
                                                        com o cruzamento de informações sobre os serviços contratados
                                                        para oferecimento de novos serviços;
                                                    </li>
                                                    <li>Desenvolvimento de nossos serviços e planos e geração de conhecimento para inovação;</li>
                                                    <li>
                                                        Marketing, prospecção, pesquisas de mercado, de opinião
                                                        e promoção dos nossos produtos e serviços, ou de nossos parceiros,
                                                        inclusive com viabilização de ofertas e envio de informações
                                                        sobre produtos, serviços, novidades, funcionalidades, conteúdos,
                                                        notícias e demais eventos relevantes para a manutenção do
                                                        relacionamento com você;
                                                    </li>
                                                    <li>Exercício de direitos da Montreal Viagens;</li>
                                                    <li>
                                                        Colaboração ou cumprimento de ordem judicial, de autoridade
                                                        competente ou de órgão fiscalizador;
                                                    </li>
                                                    <li>Cumprimento de obrigação legal;</li>
                                                </ol>
                                            </li>
                                            <li>
                                                Dados coletados a partir de terceiros
                                                <ol>
                                                    <li>Análise e concessão de crédito;</li>
                                                    <li>Prevenção a fraude;</li>
                                                    <li>Cumprimento de obrigação legal.</li>
                                                </ol>
                                            </li>
                                        </ul>
                                    </div>
                                    <div id="compartilhamento-dados-pessoais">
                                        <p><strong>2.4) Compartilhamento de dados pessoais</strong></p>
                                        <p>
                                            O compartilhamento do seus dados pessoais poderá ser feita dentro do grupo Montreal Viagens, com
                                            terceiros parceiros, fornecedores, prestadores de serviços e autoridades. Sempre que seus dados forem
                                            compartilhados, serão observadas as respectivas finalidades de tratamento,  em concordância com a
                                            legislação vigente, conforme descrito abaixo:
                                        </p>
                                        <ul class="ul-decimal">
                                            <li>
                                                Dentro do Grupo Montreal
                                                <ol>
                                                    <li>Prestação de serviços adicionais ao que você contratou;</li>
                                                    <li>
                                                        Marketing, prospecção, pesquisas de mercado, de opinião e promoção
                                                        dos nossos produtos e serviços, inclusive com viabilização de ofertas
                                                        e envio de informações sobre produtos, serviços, novidades,
                                                        funcionalidades, conteúdos, notícias e demais eventos relevantes
                                                        para a manutenção do relacionamento com você;
                                                    </li>
                                                    <li>Oferta de serviços ou produtos adicionais.</li>
                                                </ol>
                                            </li>
                                            <li>
                                                Parceiros de Negócio e fornecedores de serviços
                                                <p>
                                                    Nesta categoria estão contidos os  fornecedores de serviços hoteleiros, de atendimento ao
                                                    consumidor, de serviços estatísticos, de pesquisas, marketing, anunciantes, serviços financeiros,
                                                    meios de pagamentos e rede de hotéis parceiros da Montreal Viagens.
                                                </p>
                                                <p>
                                                    Nossos Parceiros somente são autorizados a utilizar os dados pessoais
                                                    para os fins específicos que eles foram contratados,
                                                    conforme finalidades descritas abaixo:
                                                </p>
                                                <ol>
                                                    <li>Auxiliar na prestação de serviços Montreal Viagens;</li>
                                                    <li>Cobrança de dívidas;</li>
                                                    <li>
                                                        Executar anúncios de Marketing, prospecção, pesquisas de mercado,
                                                        de opinião e promoção dos nossos produtos e serviços
                                                        Montreal Viagens;
                                                    </li>
                                                    <li>Proteção e análise de crédito;</li>
                                                    <li>Automatização de Marketing;</li>
                                                    <li>Captura de Leads;</li>
                                                    <li>Integração entre plataformas da Montreal Viagens;</li>
                                                    <li>Faturamento e cobrança dos nossos serviços;</li>
                                                    <li>Hospedagem na rede hoteleira;</li>
                                                    <li>Cumprimento de obrigação legal.</li>
                                                </ol>
                                            </li>
                                            <li>
                                                Fornecedores de serviços de tecnologia da informação
                                                <p>
                                                    Nesta categoria estão contidos os  fornecedores de serviços de tecnologia da informação no âmbito
                                                    operacional da empresa, no que tange infraestrutura e sistemas. Os fornecedores de serviços de T.I.
                                                    são regidos por contratos de confidencialidade e não possuem visibilidade dos dados pessoais
                                                    operados. As finalidades de tratamento são:
                                                </p>
                                                <ol>
                                                    <li>Infraestrutura de tecnologia e comunicação (intranet e internet);</li>
                                                    <li>Serviços em nuvem;</li>
                                                    <li>Armazenamento de dados;</li>
                                                    <li>Envio de sms;</li>
                                                    <li>Serviço de e-mail;</li>
                                                </ol>
                                            </li>
                                            <li>
                                                Autoridades
                                                <ol>
                                                    <li>Cumprimento de obrigação legal.</li>
                                                </ol>
                                                <p>
                                                    Caso queira obter maiores informações sobre o compartilhamento de
                                                    seus dados pessoais com terceiros e parceiros, entre em contato conosco
                                                    por meio dos canais descritos na sessão
                                                    <a class="target-link" (click)="scroll('target_fale_conosco')">Fale Conosco</a>
                                                    dessa política.
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div id="retencao-exclusao-dados-pessoais">
                                        <p><strong>2.5) Retenção e exclusão dos seus dados pessoais</strong></p>
                                        <p>
                                            Enquanto você for um visitante do nossos sites, um Lead Montreal Viagens ou um Cliente da Montreal Viagens,
                                            nós armazenamos seu dados pessoais em ambiente controlado e seguro.
                                            Mesmo após o cancelamento de nossos serviços, podemos, mediante o seu consentimento, manter o armazenamento dos
                                            seus dados pessoais para cumprimento de obrigações legais, oferta de novos serviços Montreal Viagens,
                                            estatísticas e identificação sua como ex-cliente Montreal Viagens.
                                        </p>
                                    </div>
                                </label>
                            </div>
                        </label>
                    </div>

                    <div id="sobre-lgpd" class="div-filtro accordion">
                        <input type="checkbox" id="btnControl-3" class="btn-control" />
                        <label class="btn" for="btnControl-3">
                            <div class="perguntas">
                                <p>
                                    <i class="fas fa-chevron-down"></i>
                                    <strong>3) Sobre a LGPD</strong><br>
                                </p>
                                <label class="area-check">
                                    <div id="introducao-lgpd">
                                        <p>
                                            A Lei Geral de Proteção de Dados (Lei 13.709/18) apresenta as diretrizes legais para o tratamento
                                            de dados pessoais em relações econômicas no âmbito dos dados coletados ou tratados em território
                                            nacional e para serviços prestados em território nacional.
                                        </p>
                                        <p class="link-lei">
                                            A lei, em sua íntegra, pode ser encontrada no endereço:
                                            <b><a target="_blank" href="http://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/l13709.htm">http://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/l13709.htm</a></b>
                                        </p>
                                    </div>
                                    <div id="papeis-definidos">
                                        <p><strong>3.1) Papéis definidos</strong></p>
                                        <p>De acordo com a Lei Geral de Proteção de Dados, foram definidos os seguintes papéis:</p>
                                        <ul class="ul-disc-title">
                                            <li><span>Titular:</span> Pessoa natural a quem se referem os dados pessoais em tratamento;</li>
                                            <li><span>Controlador:</span> Pessoa física ou jurídica a quem compete as decisões referentes ao tratamento dos dados (Viagens Montreal);</li>
                                            <li><span>Operadores:</span> Pessoas físicas ou jurídicas a quem compete o tratamento dos dados pessoais em nome do controlador (colaboradores da empresa Viagens Montreal e seus parceiros);</li>
                                            <li><span>Encarregado de dados (DPO):</span> pessoa indicada pelo controlador e operador para atuar como canal de comunicação entre o controlador, os titulares dos dados e a Autoridade Nacional de Proteção de Dados (ANPD);</li>
                                        </ul>
                                    </div>
                                    <div id="direitos-titular">
                                        <p><strong>3.2) Direitos do titular</strong></p>
                                        <p>
                                            O titular dos dados, na condição de visitante, Lead, cliente ou ex-cliente, no que tange privacidade e
                                            tratamento de dados, tem como direitos principais, de acordo com as legislações vigentes e com o
                                            contrato firmado com a empresa Montreal Viagens:
                                        </p>
                                        <ul class="ul-disc">
                                            <li>Solicitar a confirmação de que os seus dados estão sendo tratados em conformidade com esta política e com a Lei Geral de Proteção de Dados;</li>
                                            <li>Solicitar informações sobre terceiros para os quais os seus dados foram enviados;</li>
                                            <li>Solicitar ou efetuar o acesso aos seus dados caso não haja um meio claro para tal;</li>
                                            <li>Solicitar ou efetuar a correção dos seus dados;</li>
                                            <li>Solicitar a eliminação de seus dados (parcial ou total);</li>
                                            <li>Revogar o consentimento anteriormente fornecido para tratamento anteriormente fornecido;</li>
                                            <li>Restringir o tratamento dos dados pessoais por meio de recusa em fornecer o consentimento;</li>
                                            <li>Se opor ao tratamento dos seus dados quando este ocorrer em não conformidade com a legislação vigente;</li>
                                        </ul>
                                    </div>
                                    <div id="direitos-empresa">
                                        <p><strong>3.3) Direitos da empresa (controlador)</strong></p>
                                        <p>
                                            A empresa Montreal Viagens, de acordo com legislações vigentes e contrato firmado com o cliente,
                                            tem como direito:
                                        </p>
                                        <ul class="ul-disc">
                                            <li>Efetuar a coleta dos dados do usuário conforme estabelecido nesta política e com o devido consentimento do usuário;</li>
                                            <li>Efetuar o tratamento dos dados conforme estabelecido nesta política e com o devido consentimento do usuário;</li>
                                            <li>Efetuar o tratamento sem o consentimento para fins legítimos, para proteção de crédito, para cumprimento de obrigações legais ou cumprimento de contrato, conforme estabelecido na lei;</li>
                                            <li>Em caso de identificação de fraude ou violação de contrato ou dessa política, tomar as medidas cabíveis;</li>
                                        </ul>
                                    </div>
                                </label>
                            </div>
                        </label>
                    </div>

                    <div id="ferramentas-coleta-automatica" class="div-filtro accordion">
                        <input type="checkbox" id="btnControl-4" class="btn-control" />
                        <label class="btn" for="btnControl-4">
                            <div class="perguntas">
                                <p>
                                    <i class="fas fa-chevron-down"></i>
                                    <strong>4) Ferramentas de coleta automática</strong><br>
                                </p>
                                <label class="area-check">
                                    <p>
                                        Nós coletamos seus dados e registramos suas atividades de navegação ao interagir com nossos sites,
                                        landing pages ou blogs, criando o registros de atividades efetuadas nos sites e aplicativos e serviços que
                                        conterão: o acesso e ações realizadas por você, data e hora de cada ação realizada e informações sobre o
                                        dispositivo utilizado, tais como a versão de sistema operacional, navegador e endereço IP.
                                    </p>
                                    <p>As ferramentas que utilizamos são:</p>
                                    <ul class="ul-disc-title">
                                        <li><span>Cookies persistentes:</span> arquivos criados localmente no dispositivo do usuário que registram determinadas informações primárias de navegação (tais como linguagem, opções de menu e credenciais de acesso) em um site específico e mantém essas informações para facilitar ou personalizar a navegação do usuário nesse site. Possuem longo período de expiração.</li>
                                        <li><span>Cookies de sessão:</span> arquivos criados localmente no dispositivo do usuário que armazenam dados referentes a uma sessão de navegação, tais como carrinho de compras. Esses dados permitem uma navegação mais confortável, pois permitem que o usuário navegue livremente em outras páginas sem ter que inserir novamente essas informações. Esses cookies são temporários sua deleção ocorre ao se fechar o navegador.</li>
                                        <li><span>Analytics:</span> ferramentas de Analytics coletam informações de como se dá sua visita e interação com nossas páginas. Esses dados são usados para gerar informações estatísticas do perfil comportamental de navegação em nossas páginas e nos ajudar a entender como melhor desenhar nossos serviços de acordo com os interesses do usuário.</li>
                                    </ul>
                                    <p>
                                        Todas as tecnologias que utilizamos para registrar suas atividades sempre respeitarão os termos desta
                                        Política de Privacidade.
                                    </p>
                                </label>
                            </div>
                        </label>
                    </div>

                    <div id="transferencia-internacional-dados" class="div-filtro accordion">
                        <input type="checkbox" id="btnControl-5" class="btn-control" />
                        <label class="btn" for="btnControl-5">
                            <div class="perguntas">
                                <p>
                                    <i class="fas fa-chevron-down"></i>
                                    <strong>5) Transferência internacional de dados</strong><br>
                                </p>
                                <label class="area-check">
                                    <p>
                                        O tratamento dos dados coletados pela Montreal Viagens, especialmente devido a
                                        questões de infraestrutura de tecnologia em nuvem, pode ocorrer em servidores e
                                        serviços localizados em outros países.
                                    </p>
                                    <p>
                                        Os parceiros e fornecedores contratados pela Montreal Viagens estão localizados em
                                        países com legislação vigente acerca de proteção e privacidade de dados. Além disso, eles
                                        foram escolhidos também por apresentarem forte compromisso com privacidade,
                                        proteção de dados e segurança, sendo capazes de demonstrar mecanismos
                                        implementados para tal.
                                    </p>
                                    <p>
                                        Ressaltamos ainda que parceiros que fornecem serviços exclusivos de infraestrutura,
                                        como armazenamento, não possuem acesso aos dados que são tratados em seus
                                        ambientes.
                                    </p>
                                </label>
                            </div>
                        </label>
                    </div>

                    <div id="medidas-seguranca" class="div-filtro accordion">
                        <input type="checkbox" id="btnControl-6" class="btn-control" />
                        <label class="btn" for="btnControl-6">
                            <div class="perguntas">
                                <p>
                                    <i class="fas fa-chevron-down"></i>
                                    <strong>6) Médidas de Segurança</strong><br>
                                </p>
                                <label class="area-check">
                                    <p>
                                        A segurança dos dados é preocupação primordial da empresa e nós adotamos diversas medidas de
                                        segurança, de acordo com as melhores práticas de mercado, para assegurar a confidencialidade e
                                        integridade dos dados armazenados e dos nossos serviços. Mecanismos diversos são implementados em
                                        nossa infraestrutura de tecnologia, tais como dispositivos de segurança de rede, antivírus e controle de
                                        acesso.
                                    </p>
                                    <p>
                                        Por motivos estratégicos e pelo direito da empresa em proteger seus ativos, incluindo os dados de seus
                                        clientes, maiores informações sobre os mecanismos de segurança são de caráter sigiloso e não devem ser
                                        divulgados.
                                    </p>
                                </label>
                            </div>
                        </label>
                    </div>

                    <div id="consentimento" class="div-filtro accordion">
                        <input type="checkbox" id="btnControl-7" class="btn-control" />
                        <label class="btn" for="btnControl-7">
                            <div class="perguntas">
                                <p>
                                    <i class="fas fa-chevron-down"></i>
                                    <strong>7) Consentimento</strong><br>
                                </p>
                                <label class="area-check">
                                    <p>
                                        O seu consentimento, como titular, para o tratamento de dados pela empresa Montreal Viagens, é dado ao se
                                        realizar a navegação em nosso site e a interação com nossos canais de atendimento, produtos e serviços.
                                    </p>
                                    <p>
                                        Lembrando que o consentimento é revogável, por direito, em qualquer momento, desde que não acarrete em
                                        violação de cumprimento de contrato ou tratamento legítimo por parte da empresa.
                                    </p>
                                    <p>
                                        Vale lembrar que o tratamento de seus dados pessoais é condição necessária para
                                        que possamos prestar nossos serviços e entregar nossos produtos para você.
                                        Caso você tenha dúvidas sobre qualquer um dos termos explicados aqui,
                                        estamos à disposição em nossos canais de atendimento para ajudá-lo.
                                    </p>
                                    <p>
                                        Caso não concorde com esta Política, por favor, não continue a navegação,
                                        a interação em nossos canais e não use nossos serviços.
                                    </p>
                                </label>
                            </div>
                        </label>
                    </div>

                    <div id="fale-conosco">
                        <h5 id="target_fale_conosco">Fale Conosco</h5>
                        <p>
                            Conforme descrito na Lei Geral de Proteção de Dados (LGPD), na condição de titular de
                            dados pessoais, caso queira entrar em contato conosco poderá fazê-lo pelo canal
                            adequado, conforme definido abaixo:
                        </p>
                        <div class="columns">
                            <div class="column is-one-third">
                                <h5>E-mail para contato:</h5>
                                <p>meusdados@viagensmontreal.com</p>
                            </div>
                            <div class="column is-one-third"></div>
                            <div class="column is-one-third">
                                <h5>Encarregado de dados (DPO):</h5>
                                <p>Larissa Araújo</p>
                            </div>
                        </div>
                    </div>

                    <div id="contatos">
                        <h5 id="target_contatos">Contatos</h5>
                        <p>Confira nossos canais de comunicação abaixo.</p>
                        <a routerLink="/contatos" class="btn-verde">IR PRA CONTATOS</a>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <app-footer></app-footer>
</div>
